import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { t } from 'i18next';
import { useState } from 'react';

import SettingsPageHeader from '~pages/Settings/components/SettingsPageHeader';

import FuelPriceIndex from '../FuelPriceIndex/FuelPriceIndex';
import FuelSurchargeSchedules from '../FuelSurchargeSchedules/FuelSurchargeSchedules';

enum FuelSurchargeTab {
  SCHEDULES = 'schedules',
  INDEXES = 'indexes',
}

export default function FuelSurcharge() {
  const [selectedTab, setSelectedTab] = useState(FuelSurchargeTab.SCHEDULES);

  return (
    <>
      <SettingsPageHeader
        title={t('settings.nav_items.fuel_surcharge')}
        description={t('settings.page_descriptions.fuel_surcharge')}
      />
      <Tabs value={selectedTab} onChange={(__, value) => setSelectedTab(value)}>
        <Tab
          label={t('administration.fuel_surcharge_schedule.title')}
          value={FuelSurchargeTab.SCHEDULES}
        />
        <Tab
          label={t('administration.fuel_price_index.tab_title')}
          value={FuelSurchargeTab.INDEXES}
        />
      </Tabs>
      {selectedTab === FuelSurchargeTab.SCHEDULES && <FuelSurchargeSchedules />}
      {selectedTab === FuelSurchargeTab.INDEXES && <FuelPriceIndex />}
    </>
  );
}
